import { FooterLayout, OnboardingLayoutHeader } from "layouts/components";
import { memo, useCallback } from "react";

import styles from "./styles.module.scss";
import { Divider } from "antd";

import { createSelector } from "reselect";
import { TStore } from "models";


import OnboardingProgressBar from "layouts/onboardingProgressBar";
import { useSelector } from "react-redux";
const stateSelectorHandle = createSelector(
	(state: TStore) => state.auth.communityInvitation,
	( communityInvitation) => ({ communityInvitation }),
);
const AuthenticationLayout = (props: any) => {
	const { children } = props;
	const stateSelector = useCallback(stateSelectorHandle, []);

	const {  communityInvitation } = useSelector(stateSelector);

	return (
		<section className={styles.container}>
			<OnboardingLayoutHeader />
			{!communityInvitation ? null :	
			<>
			<Divider style={{ margin: "0px" }} />
			<OnboardingProgressBar props={""} />
			</>
			}
			<section className={styles.authenticationLayout}>
				{children}
			</section>
			<FooterLayout />
		</section>
	);
};

export default memo(AuthenticationLayout);
